import React, { Component } from "react";
import { Navbar, Nav, NavDropdown, Image } from "react-bootstrap";
import logo from "../../assets/MBWithName.png";
import { LogoutComponent } from "../../auth/logout";
import { ProfileComponent } from "../phlebo/navProfile";
import { PerformanceComponent } from "../phlebo/navPerformance";
import { LeaderboardComponent } from "../phlebo/navLeaderboard";
import { USER } from "../../constants/constant";
import { UpsellOrdersComponent } from "../phlebo/navUpsellOrders";
class NavbarHeader extends Component {
  constructor(props) {
    super(props);
    console.log(this.props);
    this.state = {
      routerTemp: this.props.routerTemp,
      userdata: USER.user,
    };
  }

  render() {
    return (
      <Navbar className="app-navbar">
        <Navbar.Brand href="#orders">
          <Image src={logo} height="25" />
        </Navbar.Brand>
        <Nav className="ml-auto">
          <NavDropdown id="basic-nav-dropdown" title={<i className="fa fa-user-circle-o user-icons" aria-hidden="true"></i>}>
            <NavDropdown.Item>
              <ProfileComponent></ProfileComponent>
            </NavDropdown.Item>
            {/* <NavDropdown.Item>
              <PerformanceComponent></PerformanceComponent>
            </NavDropdown.Item> */}
            <NavDropdown.Item>
              <LeaderboardComponent></LeaderboardComponent>
            </NavDropdown.Item>
            <NavDropdown.Item>
              <UpsellOrdersComponent></UpsellOrdersComponent>
            </NavDropdown.Item>
            <NavDropdown.Item>
              <LogoutComponent></LogoutComponent>
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </Navbar>
    );
  }
}
export default NavbarHeader;
